import { render, staticRenderFns } from "./minirank.vue?vue&type=template&id=1536620f"
import script from "./minirank.vue?vue&type=script&lang=js"
export * from "./minirank.vue?vue&type=script&lang=js"
import style0 from "./minirank.vue?vue&type=style&index=0&id=1536620f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports